import React from "react"
import { createRoot } from "react-dom/client"
import App from "../app/app.web"
import "../src/global.css"

const rootEl = document.getElementById("root")
if (!rootEl) {
  throw new Error("Root element #root not found")
}

createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
